<template>
<div class="settings">
  <!-- TODO: Enable these settings at a later date -->
  <!-- <div class="settings-header">
    <div class="avatar">
      <img src="@assets/images/icon-camera.svg" />
    </div>
  </div>
  <div class="settings-section">
    <div class="section-header">Profile</div>
    <div class="section-content">
      <div class="section-list form-field">
        <label>First Name</label>
        <baseInput inputType="text" />
      </div>
      <div class="section-list form-field">
        <label>Family Size</label>
        <baseInput inputType="text" class="col-3" />
      </div>
      <div class="section-list form-field">
        <label>Preferred Store</label>
        <baseInput inputType="text" class="col-6" />
      </div>
      <div class="section-list form-field">
        <label>Email</label>
        <baseInput inputType="email" class="col-10" />
      </div>
    </div>
  </div> -->

  <div class="settings-section">
    <div class="section-content no-pad-horizontal">
      <div class="list-item" @click="navigateToPreferences('DietOptions')" v-if="isOnboardingEnabled">Diet</div>
      <div class="list-item" @click="navigateToPreferences('HealthOptions')" v-if="isOnboardingEnabled">Health</div>
      <div class="list-item" @click="logout" v-if="!isEmbed">Logout</div>
      <div class="list-item" @click="clear">{{ $t('btnClearPlan') }}</div>
    </div>
  </div>

  <!-- <div class="settings-section">
    <div class="section-header">System</div>
    <div class="section-content">
      <div class="section-list item">
        Support
        <BaseIcon name="chevron-right" />
      </div>
      <div class="section-list item">
        Colophon
        <BaseIcon name="chevron-right" />
      </div>
    </div>
  </div> -->
</div>
</template>

<script>
import { breakpointsMixin } from 'breakpointsMixin';
import Leanplum from 'leanplum-sdk';
import { kitchenDrawerMethods, planMethods, onboardingComputed, platelistComputed, platelistMethods } from '@state/helpers';

export default {
  mixins: [breakpointsMixin],
  components: {},
  props: {
    isEmbed: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...onboardingComputed,
    ...platelistComputed,
  },
  mounted() {},
  methods: {
    ...kitchenDrawerMethods,
    ...planMethods,
    ...platelistMethods,
    navigateToPreferences(component) {
      this.navigateDeeper({
        title: component === 'DietOptions' ? 'Diet Preferences' : 'Health Options',
        component: component,
        context: this.onTabletUp ? 'drawerModal' : null,
      });
    },
    logout() {
      this.$router.push({ name: 'logout' });
    },
    clear() {
      if (this.appliedPlatelist) {
        Leanplum.track('Nutrition', {
          action: 'clear',
          meal_plan_id: this.appliedPlatelist.platelistId,
          os: 'web',
          platelist_label: this.appliedPlatelist.title,
        });
      }

      this.clearPlan();
      this.toggleDrawer();
      this.setDishToAdd(null);
      this.setDailySummary(null);
      this.setUserRequestClearPlan(true);
      this.setAppliedPlatelist(null);
      this.setIsPlanEmpty();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.settings {
  @extend %scrollable-drawer-content;

  padding: 0 0 20rem 0;

  .settings-header {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 2rem;

    .avatar {
      align-items: center;
      background-color: $color-settings-header-bg;
      border-radius: 50rem;
      display: flex;
      height: 10rem;
      justify-content: center;
      width: 10rem;
    }
  }

  .section-header {
    background-color: $color-settings-header-bg;
    color: $color-settings-header-text;
    font-size: 1.6rem;
    padding: 2rem;
  }

  .section-content {
    padding: 1rem 2rem;

    &.no-pad {
      padding: 0;
    }

    &.no-pad-horizontal {
      padding: 1rem 0;
    }

    &.no-pad-vertical {
      padding: 0 2rem;
    }
  }

  .section-list {
    display: flex;
    font-size: 1.6rem;
    justify-content: space-between;
    padding: 1.6rem 2rem 1.6rem 0;

    &:not(:last-child) {
      border-bottom: 1px solid $color-settings-section-item-border;
    }

    &.form-field {
      padding: 1rem 0 1rem 0;

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        padding-bottom: 0;
      }

      label {
        align-self: center;
        flex: 1;
        margin-bottom: 0;
      }

      input {
        flex: 2;
        margin-bottom: 0;
      }
    }

    &.item {
      &:first-child {
        padding-top: 1rem;
      }
    }
  }

  .list-item {
    align-items: center;
    background-color: $color-grocery-list-item-bg;
    border: 1px solid $color-grocery-list-item-border;
    border-radius: 1rem;
    color: $color-grocery-list-item-text;
    display: flex;
    flex: 3;
    font-size: 1.6rem;
    font-weight: 600;
    height: 6.3rem;
    line-height: 1;
    margin: 0.5rem auto;
    padding: 1.25em 1em;
    width: 90%;

    &:hover {
      cursor: pointer;
    }
  }

  .link-wrapper {
    display: flex;
    justify-content: center;
    padding: 1.5rem 2rem;

    .link-logout {
      color: rgba(black, 0.5);
      transition: 0.4s;

      &:hover {
        color: inherit;
        cursor: pointer;
      }
    }
  }
}
</style>
